import Image from 'next/image';
import type { FC } from 'react';
import { Button } from '@/DesignSystem/Component';
import { useRubikaUser, useShadUser } from '@/Module/Auth/Hook';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
export const DefaultLayoutFooterBottom: FC = () => {
  const isRubikaUser = useRubikaUser();
  const isShadUser = useShadUser();
  return <div className="border-4 border-blueFive bg-blueSeven py-2  " data-sentry-component="DefaultLayoutFooterBottom" data-sentry-source-file="DefaultLayoutFooterBottom.tsx">
      <div className="container">
        <div className="flex flex-col items-center justify-between md:flex-row">
          <div className="order-3 text-center">
            <p className="text-white">همۀ حقوق این وبسایت نزد شرکت فن آوری شبکه آموزش دانش نویان محفوظ است.</p>
          </div>
          <ul className="mb-2 flex flex-row items-center justify-center gap-4 md:order-5">
            {!isRubikaUser && <li>
                <Button target="_blank" as="a" variant="text" href="https://shad.ir/ino_school" className="!h-[50px] w-[50px] !rounded-none border-2 border-greenFour bg-white shadow-themeHover shadow-orangeThree hover:shadow-none">
                  <Image width={25} height={25} src={`${FILE_BROWSER_URL}/img/shad.svg`} alt="shad" />
                </Button>
              </li>}
            {!isRubikaUser && !isShadUser && <>
                <li>
                  <Button target="_blank" as="a" variant="text" href="https://ble.ir/ino_school" className="!h-[50px] w-[50px] !rounded-none border-2 border-greenFour bg-white shadow-themeHover shadow-greenFour hover:shadow-none">
                    <Image width={25} height={25} src={`${FILE_BROWSER_URL}/img/bale.webp`} alt="bale" />
                  </Button>
                </li>
                <li>
                  <Button target="_blank" as="a" variant="text" href="https://t.me/ino_school" className="!h-[50px] w-[50px] !rounded-none border-2 border-blueFive bg-white shadow-themeHover shadow-blueFive hover:shadow-none">
                    <Image width={25} height={25} src={`${FILE_BROWSER_URL}/img/telegram.webp`} alt="telegram" />
                  </Button>
                </li>
                <li>
                  <Button target="_blank" as="a" variant="text" href="https://www.instagram.com/ino.madrese" className="!h-[50px] w-[50px] !rounded-none border-2 border-redThree bg-white shadow-themeHover shadow-redThree hover:shadow-none">
                    <Image width={25} height={25} src={`${FILE_BROWSER_URL}/img/instagram.webp`} alt="instagram" />
                  </Button>
                </li>
              </>}
            {!isShadUser && <li>
                <Button target="_blank" as="a" variant="text" href="https://rubika.ir/ino_school" className="!h-[50px] w-[50px] !rounded-none border-2 border-orangeFive bg-white shadow-themeHover shadow-orangeFive hover:shadow-none">
                  <Image width={30} height={29} src={`${FILE_BROWSER_URL}/img/rubika.webp`} alt="rubika" />
                </Button>
              </li>}
          </ul>
        </div>
      </div>
    </div>;
};